import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GenerateTanArgs, GenerateTanRequestBody, GeneratedTan } from './identification-tan.model';

/**
 * Client for issuing identification TANs (6-digit code a colleague uses to
 * authenticate on behalf of a customer over the phone).
 *
 * Real endpoint: `POST /phoneservice/v3/employees/{employeeId}/tans`.
 * Target employee is in the path; body carries issuer + UA + validity.
 */
@Injectable({ providedIn: 'root' })
export class IdentificationTanApiService {
  private readonly http = inject(HttpClient);

  generateTan(args: GenerateTanArgs): Observable<GeneratedTan> {
    const body: GenerateTanRequestBody = {
      issuedByEmployee: args.issuedByEmployee,
      userAccountId: args.userAccountId,
      validityHours: args.validityHours,
    };

    return this.http.post<GeneratedTan>(
      `${environment.phoneServiceUrl}/employees/${args.targetEmployeeId}/tans`,
      body,
    );
  }
}
